export default "__VITE_ASSET__CcT4o9tr__"